// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentId } from "./constants";
import type { GenerativeAiAgentIdResult } from "./types";
import { isGenerativeAiAgentIdResult } from "./validators";

export const getGenerativeAiAgentId = reactQueryFetcherAdapter(
  generativeAiAgentId,
  (signal: AbortSignal, id: string): Promise<GenerativeAiAgentIdResult> => {
    return fetch(`/generative_ai/agent/${id}`, "GET", {}, { signal });
  },
  isGenerativeAiAgentIdResult
);
